export class Paginated<T>
{
	data: T[];
	meta: {
		pagination: {
			total: number,
			current_page: number,
			total_pages: number,
			per_page: number
		}
	};

	constructor()
	{
		this.data = new Array<T>();
		this.meta = {
			pagination: {
				total: 0,
				current_page: 0,
				total_pages: 0,
				per_page: 0
			}
		};
	}
}


// WEBPACK FOOTER //
// ./src/app/models/paginated.ts